<template>

  <div class="main-container">

    <section  class="container mt-0 pt-0">

        <div class="row">

          <div class="col-12 offset-0 col-md-6 offset-md-3 text-center mt-5">

            <h4 class="text-danger  font-weight-light">We are sorry!</h4>
            <p class="text-danger font-weight-light">
              We could not find that page.
            </p>

          </div>

        </div>

      </section>

  </div>
  
</template>

<script>
  
  export default {
    name: 'Error',
  }
  
</script>
